<app-q1-feedback-layout>
  <div class="wrap">
    <img class="icon" src="/assets/img/game/select.svg">
    <div class="text-wrap">
      <div>Fantastic! All of your choices are great stores to focus on.</div>
      <div class="pink">Please begin your journey by tapping below.</div>
    </div>
    <app-button
      [text]="'Continue'"
      (click)="onContinueClick()"
    ></app-button>
  </div>
</app-q1-feedback-layout>